import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {withCookies, Cookies} from 'react-cookie';
import {Helmet} from "react-helmet";
import request from 'superagent';
import {withAlert} from "react-alert";
import API from '../config/API';
import './AuthPage.scss';

class AuthPage extends Component {

    static propTypes = {
        cookies: PropTypes.instanceOf(Cookies).isRequired,
        redirectPath: PropTypes.string,
        // eslint-disable-next-line react/forbid-prop-types
        alert: PropTypes.object.isRequired
    };

    static defaultProps = {
        redirectPath: '/'
    };

    state = {
        username: '',
        password: ''
    };

    onSubmit = (e, alert) => {
        e.preventDefault();

		const apiHost = API.getHost();

        if (window.lin) {
            this.props.cookies.set('x-auth-token', window.lin.at, {path: '/', maxAge: window.lin.ein});
            this.props.cookies.set('x-auth-refresh-token', window.lin.rt, {path: '/'});
            window.location = this.props.redirectPath;
        }


        request.post(`${apiHost}/oauth/token?_type=json`)
            .type('form')
            .send({username: this.state.username})
            .send({password: this.state.password})
            .send({grant_type: 'password'})
            .send({client_id: API.clientId})
            .send({client_secret: API.clientSecret})
            .end((err, res) => {
                // Display Password Error
                if (err || !res.body.access_token) {
                    alert.error('The username or password you have entered is incorrect. For password assistance please contact <a href="/contact-us" style="color: #fff">Client Services</a>.');
                    return null;
                }

                this.props.cookies.set('x-auth-token', res.body.access_token, {path: '/', maxAge: res.body.expires_in});
                this.props.cookies.set('x-auth-refresh-token', res.body.refresh_token, {path: '/'});

                // Redirect Home
                window.location = this.props.redirectPath;
                return true;
        });
    };

    handleChange = (key, event) => {
        this.setState({[key]: event.target.value});
    };

    render() {

        const {alert} = this.props;

		const apiHost = API.getHost();

        return (
            <div className="page-auth">
                <Helmet>
                    <title>Login | MarketAxess</title>
                </Helmet>

                <div className="main">

                    <div className="form__container">

                        <div className="container">
                            <h1>Login</h1>
                        </div>

                        <div className="container">
                            <form action={`${apiHost}/oauth/token?_type=json`} method="POST" onSubmit={e => this.onSubmit(e, alert)} className="authForm">
                                <div className="form__input">
                                    <label htmlFor="username">
                                        Username
                                        <input type="text" id="username" name="username" value={this.state.username} onChange={(e) => this.handleChange('username', e)}/>
                                    </label>
                                </div>

                                <div className="form__input">
                                    <label htmlFor="password" className="authPagePassword">
                                        <div className="authPagePassword__label">
                                            <span>Password</span>
                                            <span className="authPagePassword--desktop">
                                                <a className="authPagePassword__reset" href="mailto:cs@traxmarkets.com?subject=Requesting%20assistance%20with%20my%20login%20and/or%20password">Click here for password assistance</a>
                                            </span>
                                        </div>
                                        <input type="password" id="password" name="password" value={this.state.password} onChange={(e) => this.handleChange('password', e)}/>

                                        <span className="authPagePassword--mobile">
                                            <a className="authPagePassword__reset" href="mailto:cs@traxmarkets.com?subject=Requesting%20assistance%20with%20my%20login%20and/or%20password">Click here for password assistance</a>
                                        </span>

                                    </label>
                                </div>

                                <button type="submit">Submit</button>
                            </form>
                        </div>

                    </div>

                </div>

            </div>
        );
    }
}

export default withCookies(withAlert()(AuthPage));



// WEBPACK FOOTER //
// ./frontend/pages/AuthPage.jsx